import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk } from '../../store'; // Adjust the import according to your setup

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const VERSION = process.env.REACT_APP_API_VERSION;

type ParticipantStudyAnalytics = {
  homeostasisData: number; // range: 70 - 90
  activityData: number; // range: 0 - 5
  hotData: number; // range: 0 - 5
  offWristData: number; // range: 0 - 5
  coldData: number; // range: 0 - 5
  noData: number; // Always 0
}

type ParticipantStudyDetails = {
  isPinned: boolean;
  hasAnomaly: boolean;
  anomalyPercentage: number; // range: 0 to 10
  hasError: boolean;
  participantID: string; // Example: 'LAS001NNN'
  dailyData: ParticipantStudyAnalytics;
  weeklyData: ParticipantStudyAnalytics;
  lastUpdate: string;
};
// Define the initial state for SensorDetails
const anomalyDataDetails: ParticipantStudyDetails[] = [];

const tempRangeAnomalyDataSlice = createSlice({
  name: 'tempRangeAnomalyDataDetails',
  initialState: { anomalyData: anomalyDataDetails },
  reducers: {
    // update multiple sensors
    updateData: (state, action: PayloadAction<ParticipantStudyDetails[]>) => {
      state.anomalyData = action.payload;
    },
  },
});

export const { updateData } = tempRangeAnomalyDataSlice.actions;

export default tempRangeAnomalyDataSlice.reducer;


// {
//   "device_uuid": "EEEDA53C8165",
//   "ispinned": false,
//   "hasanomaly": false,
//   "anomalypercentage": 0.2746280477056338,
//   "haserror": false,
//   "daily_homeostasisdata": 87.6992,
//   "daily_activitydata": 1.8787,
//   "daily_hotdata": 0,
//   "daily_offwristdata": 6.3913,
//   "daily_colddata": 4.0308,
//   "daily_nodata": 0,
//   "weekly_homeostasisdata": 80.3144,
//   "weekly_activitydata": 3.661,
//   "weekly_hotdata": 0.0399,
//   "weekly_offwristdata": 10.3787,
//   "weekly_colddata": 5.6061,
//   "weekly_nodata": 0,
//   "last_sync_time": "2024-03-06T13:33:26.866052",
//   "study_id": 123,
//   "euid": "859a8e61-c808-4a58-a910-9e65e8ff2fb0",
//   "study_participant_id": "GuyP2"
// }





function mapTempRangeAnomalyDataToParticipantStudyDetails(tempRangeAnomalyData: { device_uuid : string, 
                                                                                  hasanomaly : boolean, 
                                                                                  anomalypercentage: number,  
                                                                                  haserror : boolean,
                                                                                  daily_homeostasisdata : number,
                                                                                  daily_activitydata : number,
                                                                                  daily_hotdata : number,
                                                                                  daily_offwristdata : number,
                                                                                  daily_colddata : number,
                                                                                  daily_nodata : number,
                                                                                  weekly_homeostasisdata : number,
                                                                                  weekly_activitydata : number,
                                                                                  weekly_hotdata : number,
                                                                                  weekly_offwristdata : number,
                                                                                  weekly_colddata : number,
                                                                                  weekly_nodata : number,
                                                                                  last_sync_time : string,
                                                                                  study_id : number,
                                                                                  study_participant_id : string
                                                                                }[]): ParticipantStudyDetails[] {
  return tempRangeAnomalyData.map(t => ({
    "isPinned": false,
    "hasAnomaly": t.hasanomaly,
    "anomalyPercentage": Math.floor(t.anomalypercentage * 10),
    "hasError": t.haserror,
    "participantID": t.study_participant_id,
    "dailyData": {
      "homeostasisData": t.daily_homeostasisdata,
      "activityData": t.daily_activitydata,
      "hotData": t.daily_hotdata,
      "offWristData": t.daily_offwristdata,
      "coldData": t.daily_colddata,
      "noData": t.daily_nodata
    },
    "weeklyData": {
      "homeostasisData": t.weekly_homeostasisdata,
      "activityData": t.weekly_activitydata,
      "hotData": t.weekly_hotdata,
      "offWristData": t.weekly_offwristdata,
      "coldData": t.weekly_colddata,
      "noData": t.weekly_nodata
    },
    "lastUpdate": t.last_sync_time
  }));
}

export const fetchtempRangeAnomalyDataDetails = (): AppThunk => async (dispatch, getState) => {
    const state = getState();
    const { anomalyData } = state.tempRangeAnomalyDataDetail;

    let alreadyInitialized : boolean = false;
  
    // Check if the state is not empty
    if (anomalyData.length > 0 || alreadyInitialized ) {
      // Data is already present, so skip the API call
      return;
    }
  
    // Make the API call to fetch sensor details
    try {
      const response = await fetch(`${BASE_URL}/getAllData`);
      // const data: SensorDetails[] = await response.json();

      if (!response.ok) {
        console.log('Failed to fetch data')
        throw new Error('Failed to fetch data');
      }
      const result = await response.json();

      console.log("Temp Range Anomaly Data Details:", JSON.parse(result['body']))

      const tempRangeAnomalyDetailsArray = mapTempRangeAnomalyDataToParticipantStudyDetails(JSON.parse(result['body']));
  
      // Dispatch the action to update the sensors in the store
      dispatch(updateData(tempRangeAnomalyDetailsArray));

      console.log("Processed Temp Range Anomaly Data Details:", tempRangeAnomalyDetailsArray)

      alreadyInitialized = true;

    } catch (error) {
      console.error('Failed to fetch sensor details:', error);
    }
  };

  export const reloadtempRangeAnomalyDataDetails = (): AppThunk => async (dispatch, getState) => {
    const state = getState();
  
    // Make the API call to fetch sensor details
    try {
      const response = await fetch(`${BASE_URL}/getAllData`);
      // const data: SensorDetails[] = await response.json();

      if (!response.ok) {
        console.log('Failed to fetch data')
        throw new Error('Failed to fetch data');
      }
      const result = await response.json();

      console.log("Got new data")

      console.log("Anomalous Participants Details:", JSON.parse(result['body']))

      const tempRangeAnomalyDetailsArray = mapTempRangeAnomalyDataToParticipantStudyDetails(JSON.parse(result['body']));
  
      // Dispatch the action to update the sensors in the store
      dispatch(updateData(tempRangeAnomalyDetailsArray));

    } catch (error) {
      console.error('Failed to fetch sensor details:', error);
    }
  };
  